// Genere par tools/gen-icons.mjs. Ne pas editer a la main.
import { createRemixIcon } from '../create-remix-icon.js';

export const IconContactBook = createRemixIcon('IconContactBook', "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.75.75h20.5v22.5H2.75v-4H1v-2.5h1.75v-3.5H1v-2.5h1.75v-3.5H1v-2.5h1.75zm2.5 20v-1.5H7v-2.5H5.25v-3.5H7v-2.5H5.25v-3.5H7v-2.5H5.25v-1.5h15.5v17.5zM18 6h-8v4h8z\" clip-rule=\"evenodd\"/>");
